angular.module('rightPaneModule')
  .controller('ClassroomConceptsController', ['$scope', '$window', '$modal',
    function($scope, $window, $modal) {

    var initializeData = function(e, item) {
      $scope.item = item;
    };

    $scope.openConceptMap = function() {

        var modal = $modal.open({
            templateUrl: 'resources/concept-map/partials/concept-map-modal.html',
            windowClass: 'concept-map-modal',
            controller: 'ConceptMapModalController',
            backdrop: 'static',
            scope: $scope,
            resolve: {
                mapContext: function() {
                    return {viewMode: 'classroom'};
                }
            }
        });

    };

    $scope.$on('itemReady', initializeData);
  }
]);
